import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useIsQuestionnaireReportFilterApplied } from '../../hooks';
import { QuestionnaireReportExportModal } from '../questionnaire-report-export-modal';

export default function QuestionnaireReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();

  const isFilterApplied = useIsQuestionnaireReportFilterApplied();

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={openModal}
        disabled={!isFilterApplied}
      >
        Export
      </Button>
      <QuestionnaireReportExportModal open={isModalOpen} onClose={closeModal} />
    </>
  );
}
